import { useMemo } from "react";

export default function useSelectedHiddenLocations(value) {
  const selectedHiddenLocations = useMemo(() => {
    if (value.warehouse_locations && Array.isArray(value.warehouse_locations) && value.warehouse_locations.length > 0) {
      const locations = value.warehouse_locations.map(warehouseLocationObj => {
        const location = {
          id: warehouseLocationObj.id,
          locationId: warehouseLocationObj.location_id,
          locationName: warehouseLocationObj.location_name,
          zone: warehouseLocationObj.zone,
          warehouse: value.warehouse,
          warehouseId: value.warehouse?.warehouse_id,
          warehouseName: value.warehouse?.name,
          mobile_warehouse_location: value.mobile_warehouse_location,
        };

        return {
          visible: false,
          ...location,
          locations: [location],
        };
      });

      return locations;
    }

    const warehouseLocationObj = value.warehouse_location;
    
    if (!warehouseLocationObj) {
      return [];
    }

    const location = {
      id: warehouseLocationObj.id,
      locationId: warehouseLocationObj.location_id,
      locationName: warehouseLocationObj.location_name,
      zone: warehouseLocationObj.zone,
      warehouse: value.warehouse,
      warehouseId: value.warehouse?.warehouse_id,
      warehouseName: value.warehouse?.name,
      mobile_warehouse_location: value.mobile_warehouse_location,
    };
    
    return [{
      visible: false,
      ...location,
      locations: [location],
    }];
  }, [value]);

  return selectedHiddenLocations;
}
